module.exports = __webpack_public_path__ + "img/SamsungGalaxyS9Plus.3ddaa589.png";